import { channels } from "@swa-ui/application";

export const siteToChannel = {
  corporate: channels.corporate,
  leisure: channels.southwest,
  mobile: channels.mweb,
  southwest: channels.southwest,
};
